import * as React from "react";
import * as Loadable from "react-loadable";

import { Loading } from "./DataContainer";

export function lazy<P>(
  loader: () => Promise<
    React.ComponentType<P> | { default: React.ComponentType<P> }
  >,
  loading?: React.ComponentType<Loadable.LoadingComponentProps>
) {
  return Loadable({
    loader: loader,
    loading: loading || (() => <Loading />),
  });
}
